import { useQuery, useMutation } from '@tanstack/react-query';
import { ticketsApi } from '../services/api';

export const useTickets = ({ enabled = true } = {}) => {
  const getTickets = useQuery({
    queryKey: ['tickets'],
    queryFn: () => ticketsApi.getAll(),
    staleTime: 0, // Данные сразу считаются устаревшими
    cacheTime: 0, // Полностью отключаем кэширование
    refetchOnMount: 'always', // Всегда обновлять данные при монтировании компонента
    refetchOnWindowFocus: true, // Обновлять данные при возвращении фокуса на окно
    refetchInterval: 5000, // Обновлять данные каждые 5 секунд
    enabled: enabled
  });

  const createTicket = useMutation({
    mutationFn: (data) => ticketsApi.create(data),
    onSuccess: () => {
      getTickets.refetch();
    },
  });

  const updateTicket = useMutation({
    mutationFn: (data) => ticketsApi.update(data.id, data.ticket),
    onSuccess: () => {
      getTickets.refetch();
    },
  });

  const deleteTicket = useMutation({
    mutationFn: (id) => ticketsApi.delete(id),
    onSuccess: () => {
      getTickets.refetch();
    },
  });

  const addComment = useMutation({
    mutationFn: (data) => ticketsApi.addComment(data.ticketId, data.comment),
    onSuccess: () => {
      getTickets.refetch();
    },
  });

  return {
    tickets: getTickets.data?.data || [],
    isLoading: getTickets.isLoading,
    error: getTickets.error,
    createTicket: createTicket.mutateAsync,
    updateTicket: updateTicket.mutateAsync,
    deleteTicket: deleteTicket.mutateAsync,
    addComment: addComment.mutateAsync,
    refetch: getTickets.refetch
  };
};
